import type { BlogPost } from '../types';

export const post: BlogPost = {
  "id": "305",
  "slug": "spot-colombia-from-satellite-imagery",
  "title": "How to Recognise Colombia in Satellite Images",
  "excerpt": "Western Colombia has several Andean ranges separated by valleys.",
  "date": "2026-04-03",
  "category": "Geography",
  "series": "Spot the Country",
  "image": "/blog-images/colombia.jpg",
  "readTime": "1 min",
  "content": [
    {
      "type": "paragraph",
      "text": "Western Colombia has several Andean ranges separated by valleys. Lower ground extends east towards the Orinoco and Amazon basins. The country reaches both the Caribbean and Pacific, so a coastline in a Colombian image may have a very different setting depending on which side you see."
    },
    {
      "type": "heading",
      "text": "The Andes split into separate ranges"
    },
    {
      "type": "paragraph",
      "text": "Trace the Magdalena valley between mountain belts, then compare it with the lowlands east of the Andes. Notice how the river network changes with the relief."
    },
    {
      "type": "heading",
      "text": "Similar landscapes across borders"
    },
    {
      "type": "paragraph",
      "text": "Mountain farming can resemble Ecuador or Peru, while eastern forest continues into Brazil. A green valley alone is insufficient. Try to establish whether the river runs between ranges or across a lowland plain."
    }
  ],
  "imageAlt": "Colombia regional satellite composite with shaded relief",
  "imageCaption": "NASA Earth Observatory / MODIS, August 2004. Regional composite with shaded relief and bathymetry; it shows landforms, not political boundaries or current conditions.",
  "sources": [
    {
      "title": "NASA: Blue Marble Next Generation (image source)",
      "url": "https://science.nasa.gov/earth/earth-observatory/blue-marble-next-generation/"
    }
  ]
};
